export enum ESIMULATION {
  DPO = 'DPO',
  LP = 'LANDING_PAGE',
}
